// A one-line stand-in for `router.refresh()`. The pages used to be server
// components, so any write just asked Next to re-render them; here a write
// broadcasts, and every mounted useApi refetches.

const EVENT = "app-refresh";

export function refreshData(): void {
  window.dispatchEvent(new Event(EVENT));
}

export function onRefresh(callback: () => void): () => void {
  window.addEventListener(EVENT, callback);
  return () => window.removeEventListener(EVENT, callback);
}
